'use client';

import { createContext, ReactNode, useCallback, useState } from 'react';

export interface ToastMessage {
    id: string;
    variant: 'danger' | 'warning' | 'info' | 'success';
    message: string;
}

interface ToastContextValue {
    toasts: ToastMessage[];
    addToast: (variant: ToastMessage['variant'], message: string) => void;
    removeToast: (id: string) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

interface Props {
    children: ReactNode;
}

export function ToastProvider({ children }: Props) {
    const [toasts, setToasts] = useState<ToastMessage[]>([]);

    const addToast = useCallback((variant: ToastMessage['variant'], message: string) => {
        const id = Math.random().toString(36).substring(2, 11);
        const newToast: ToastMessage = { id, variant, message };

        setToasts(prev => [...prev, newToast]);

        setTimeout(() => {
            setToasts(prev => prev.filter(toast => toast.id !== id));
        }, 5000);
    }, []);

    const removeToast = useCallback((id: string) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    }, []);

    return <ToastContext.Provider value={{ toasts, addToast, removeToast }}>{children}</ToastContext.Provider>;
}
